import React from "react";
import getCorePopUpStore from "../../../../stores/core/core-popup-store";
import ET3Div from "../../../et3-div";
import { withLiteObserverAndTheme } from "../../../et3-enhanced-render";
import Et3Text from "../../../et3-text";
import { TEt3PickerSingleValue, TEt3PickerOption } from "../../../../TypesNEW";
import Et3Picker from "../../../et3-input/et3-picker";

const EditPopUpBody = withLiteObserverAndTheme<{ options: TEt3PickerOption[] }>(
  (props) => {
    const { theme, options } = props;
    const { colors } = theme;

    const editPopUpVisibleType = getCorePopUpStore().editPopUpVisibleType.get();
    return (
      <React.Fragment>
        <ET3Div
          isScrollable={false}
          isExtendable={false}
          withShadow={false}
          width={350}
          height={20}
          fDirection="column"
          alignItems="center"
          justifyContent="center"
          color={colors.all.transparent}
          style={{}}
          onClick={() => {}}
        >
          <Et3Text
            fontFamily={"BOLD"}
            fontSize={20}
            text={`${editPopUpVisibleType}`}
            isSpan={false}
            color={colors.all.maastrichtBlue}
            style={{}}
          />
        </ET3Div>
        <ET3Div
          isScrollable={false}
          isExtendable={false}
          fDirection="row"
          justifyContent="center"
          alignItems="flex-start"
          withShadow={false}
          width={300}
          height={100}
          color={colors.all.transparent}
          style={{}}
          onClick={() => {}}
        >
          <Et3Picker
            label={""}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: 6
            }}
            options={options}
            value={getCorePopUpStore().editPopUpValue.get()}
            onChoose={(value: TEt3PickerSingleValue) => {
              getCorePopUpStore().setEditPopUpValue(value);
            }}
            onClick={() => {}}
            isMultiple={false}
            onEnter={() => {}}
            containerStyle={{}}
          />
        </ET3Div>
      </React.Fragment>
    );
  }
);

export default EditPopUpBody;
